var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetermine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_983_30734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6579 14.8885C11.4907 14.8181 14.019 14.7732 14.7152 15.0615C15.2042 15.2622 15.6996 15.7961 15.8619 16.3C15.8961 16.4047 15.9772 16.7207 15.9473 16.8083C15.8982 16.9535 14.8711 17.5108 14.6746 17.5962C12.8403 18.397 10.5767 18.2134 8.93886 17.0453C8.72319 16.8915 8.63136 16.8787 8.65912 16.5883C8.74881 15.5996 9.74605 14.9675 10.6579 14.8885Z",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5675 18.2461H18.3857V21.4279H21.5675V18.2461Z",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9194 2.91452C22.072 2.86968 22.0634 6.13901 19.9536 6.1326C17.8438 6.12619 17.8652 2.95723 19.9194 2.91452Z",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.61452 2.90234L6.22462 4.51245L4.64868 6.12256L3.03857 4.51245L4.61452 2.90234Z",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.27588 21.4251L4.60838 18.7109L5.98786 21.4251H3.27588Z",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.61381 19.2267C5.60313 19.043 5.3298 18.7804 5.40027 18.6202L7.36485 16.6514C7.4823 16.536 7.87949 16.993 7.83678 17.0742L5.61167 19.2267H5.61381Z",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11171 5.57031L7.90546 7.32136C7.76666 7.40677 7.52749 7.83172 7.36733 7.72282L5.66113 6.01234L6.11171 5.57031Z",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1746 5.84766C18.2963 6.0313 18.4351 6.1701 18.6188 6.29182L17.1453 7.76526L16.7012 7.3211L18.1746 5.84766Z",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49554 11.5669C4.42017 11.3747 4.57606 12.6282 3.83934 12.799C2.95527 13.0019 2.75668 11.7206 3.49554 11.5669Z",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1999 20.1733C13.2484 20.0217 13.0968 21.7856 12.0376 21.3905C11.4525 21.1706 11.5763 20.2652 12.1999 20.1733Z",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2807 2.92595C12.9683 2.911 13.1861 3.87835 12.5369 4.13887C11.576 4.52538 11.2984 2.94731 12.2807 2.92595Z",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7584 11.5661C21.4503 11.4252 21.8624 12.2921 21.2816 12.6979C20.4167 13.3043 19.8466 11.7519 20.7584 11.5661Z",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1509 17.5875C17.8498 17.5833 17.7153 17.7797 17.7068 18.0552L16.7031 17.0088C16.8505 16.9384 17.0512 16.5775 17.1836 16.6117C17.316 16.6458 17.9908 17.4445 18.1509 17.5875Z",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6312 4.82031V5.5912C12.6312 5.70865 12.0781 5.64672 11.9756 5.66167V4.82031H12.6312Z",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6331 18.7109H11.9775V19.5523H12.6331V18.7109Z",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75493 11.8828V12.4914H4.91357C4.9691 12.2736 4.9691 12.1028 4.91357 11.8828H5.75493Z",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6949 11.8828C19.6201 12.0686 19.6201 12.3056 19.6949 12.4914H18.8535V11.8828H19.6949Z",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88281 9.80664C8.29006 6.59924 12.17 5.31121 15.2344 7.05371C18.5476 8.93892 19.2414 13.5748 16.5146 16.2764C16.2277 15.1842 15.2395 14.3436 14.1064 14.2646C13.105 14.1942 11.4503 14.1878 10.4531 14.2646C9.32787 14.3522 8.36626 15.2044 8.06934 16.2783C6.37421 14.6319 5.93912 11.9611 6.88281 9.80664ZM16.5156 16.2783H16.5137L16.5146 16.2764L16.5156 16.2783ZM12.0605 8.19824L11.7793 8.23828C8.9829 8.78744 9.41018 13.333 12.6963 12.9512C15.5513 12.618 15.2358 7.90153 12.0605 8.19824ZM12.1074 8.69629C12.7669 8.63475 13.238 8.83165 13.5586 9.13281C13.8889 9.44335 14.0931 9.89755 14.1426 10.3887C14.2431 11.3885 13.7151 12.3295 12.6387 12.4551C11.9175 12.5389 11.4043 12.3424 11.0596 12.04C10.7063 11.73 10.4908 11.2736 10.4404 10.7812C10.3901 10.288 10.5083 9.79019 10.7803 9.41016C11.0451 9.04031 11.4734 8.75574 12.1074 8.69629Z",
    fill: "#090909"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_983_30734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetermine);
export default __webpack_public_path__ + "static/media/determine.616a01621ab7a511dc0111cc70a0e7f7.svg";
export { ForwardRef as ReactComponent };